import { render, staticRenderFns } from "./zhaqBanKuai.vue?vue&type=template&id=6c4acd54&scoped=true"
import script from "./zhaqBanKuai.vue?vue&type=script&lang=js"
export * from "./zhaqBanKuai.vue?vue&type=script&lang=js"
import style0 from "./zhaqBanKuai.vue?vue&type=style&index=0&id=6c4acd54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4acd54",
  null
  
)

export default component.exports